





import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'

@Component
export default class ClickAway extends Vue {
  @Prop(Boolean) readonly trigger: boolean | undefined

  mounted () {
    window.onclick = (event: Event) => {
      if (this.trigger) {
        let element: Element | null = event.target as Element
        // go up the path until no further parent or clickaway found
        while (element && element.id !== 'clickaway') {
          element = element.parentElement
        }
        if (!element) {
          this.$emit('outside')
        }
      }
    }
  }
}
